import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { Panel, Alert, Row, Col } from 'react-bootstrap'
import 'moment-duration-format'
import { holdStatusReset, extendHoldTimer } from '../redux/actions'
import ExtendSessionModal from '../components/modals/ExtendSessionModal'
import moment from 'moment'
import { search } from '../redux/actions'
import history from '../history'

let { closeWarningDialog } = search
@autobind
class HoldTimer extends Component {
  static propTypes = {
    holdStatus: PropTypes.object,
    dispatch: PropTypes.func,
    auth: PropTypes.object
  }

  handleSearchRestartClick(event) {
    event.preventDefault()
    this.props.dispatch(holdStatusReset())
    history.push('/search')
  }

  render() {
    let {
      holdStatus: { status, timeLeft, warnTime, show, closedPopup },
      auth: { authenticated },
      dispatch
    } = this.props
    if (status === 'active') {
      let timeDisplay = timeLeft.format('mm:ss', { trim: false })
      return (
        <div>
          <Row>
            <Col xs={12} lg={12}>
              <Col sm={8} xs={6} className='panel mobile-aligner'>
                <h3 className='status-msg'>
                  Your selected rooms are temporarily reserved for you
                </h3>
              </Col>
              {authenticated ? (
                <Col sm={2} xs={5} className='timer-box pull-right'>
                  <Row>
                    <Col sm={12} style={{ marginTop: '0rem' }}>
                      Time Left: <br />
                      {timeDisplay}
                    </Col>
                  </Row>
                </Col>
              ) : (
                ''
              )}
              <ExtendSessionModal
                {...this.props}
                show={moment().isAfter(warnTime) && show && !closedPopup}
                onClose={() => dispatch(closeWarningDialog())}
                extendSession={() => dispatch(extendHoldTimer())}
              />
            </Col>
          </Row>
        </div>
      )
    } else if (status === 'expired') {
      return (
        <Alert bsStyle='danger'>
          <h4>Your hold has expired!</h4>
        </Alert>
      )
    } else {
      return null
    }
  }
}

// Which props do we want to inject, given the global state?
function selectProps(state) {
  return {
    holdStatus: state.roomSearch.holdStatus,
    auth: state.common.authentication
  }
}

export default connect(selectProps)(HoldTimer)



// WEBPACK FOOTER //
// ./src/containers/holdTimer.js